import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {User} from '../../models/user';
import {Paginator} from '../../models/paginator';
import {ApiImplementation} from '../api/api-implementation.service';

@Injectable()
export class UserService extends ApiImplementation {

  protected base: string = 'v1/users';
  protected primaryKey: string = 'id';

  public currentUser: User = new User();

  constructor(protected api: ApiService) {
    super(api)
  }

  public currentUserAllowedInEmployeeApp() {
    if (this.currentUser && this.currentUser.hasOwnProperty('roles')) {
      return this.isAllowedInEmployeeApp(this.currentUser);
    } else {
      return false;
    }
  }

  public currentUserInRole(role_to_check: string) {
    if (this.currentUser.hasOwnProperty('roles')) {
      for (const role of this.currentUser.roles) {
        if (role.name === role_to_check) {
          return true;
        }
      }
    }
    return false;
  }

  public canAccessMessages(user: User = null) {
    if (!user) {
      user = this.currentUser;
    }
    if (user.hasOwnProperty('roles')) {
      for (const role of user.roles) {
        switch (role.name) {
          case 'superadmin':
          case 'admin':
          case 'group_leader':
          case 'location_manager':
            return true;
          case 'group_assistant':
          case 'assistent':
          default:
            return false;
        }
      }
    }
    return false;
  }

  public isAllowedInEmployeeApp(user: User) {
    if (user.hasOwnProperty('roles')) {
      for (const role of user.roles) {
        switch (role.name) {
          case 'superadmin':
          case 'admin':
          case 'location_manager':
          case 'group_leader':
          case 'group_assistant':
          case 'assistent':
            return true;
          default:
            return false;
        }
      }
    }
    return false;
  }

  public self() {
    return this.api.get(this.base + '/self').then(data => {
      return this.transform(data['data']);
    });
  }

  model(data?) {
    return new User(data);
  }

  paginator(data) {
    return new Paginator<User>(data);
  }

  public all(limit = 100, page = 1): Promise<Paginator<User>> {
    return super.all(limit, page) as Promise<Paginator<User>>;
  }

  public get(id: number) {
    return super.get(id) as Promise<User>;
  }

  public delete(user: User) {
    return super.delete(user);
  }

  public save(user: User): Promise<User> {
    return super.save(user) as Promise<User>;
  }

  public changePassword(passwordInfo: { password: string, new_password: string, new_password_confirmation: string }) {
    return this.api.put(this.base + '/update-password', passwordInfo);
  }

  isAssistant() {
    return this.currentUserInRole('group_assistant') || this.currentUserInRole('assistent')
  }

  canViewNotes() {
    // only location manager up can view notes
    const canView = this.currentUserInRole('superadmin') ||
      this.currentUserInRole('admin') ||
      this.currentUserInRole('location_manager');
    return canView;
  }
}
